import {
    ResourceAllocationState,
    WorkingHoursConfig,
    RagThresholdConfig,
    UtilisationConfig
} from '../../../types';

// Effective-dated config broadcasts carry the full version series plus the
// current-week resolution (see ConfigBroadcast.cs).
interface ConfigVersionsPayload<T> {
    versions: T[];
    current: T;
}

export const configHandlers = {
    WorkingHoursConfigUpdated: (
        state: ResourceAllocationState,
        data: ConfigVersionsPayload<WorkingHoursConfig>
    ): ResourceAllocationState => {
        return {
            ...state,
            workingHoursConfig: data.current,
            workingHoursConfigVersions: data.versions
        };
    },
    RagThresholdConfigUpdated: (
        state: ResourceAllocationState,
        data: ConfigVersionsPayload<RagThresholdConfig>
    ): ResourceAllocationState => {
        return {
            ...state,
            ragThresholdConfig: data.current,
            ragThresholdConfigVersions: data.versions
        };
    },
    UtilisationConfigUpdated: (
        state: ResourceAllocationState,
        data: ConfigVersionsPayload<UtilisationConfig>
    ): ResourceAllocationState => {
        return {
            ...state,
            utilisationConfig: data.current,
            utilisationConfigVersions: data.versions
        };
    }
};
